import React from 'react';
import styled from 'styled-components';
import { width, display, padding, space } from 'styled-system';
import Button from '../shared/Button';
import { scroller } from 'react-scroll';
import Icon from '../shared/Icon';
import { palette } from '../../constants/styles';
import { withRouter } from 'react-router-dom';

const StyledFollowingCTA = styled.div`
  position: fixed;
  bottom: 0px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 60px;
  ${display}
  ${width}
  ${space}
  z-index: 10000;
  background-color: ${palette.primaryColor};
`;

const StyledGoToTableOfContents = styled(Button)`
  width: 60px;
  margin: 10px;
  background-color: gray;
  cursor: pointer;
`;

const StyledCTAButton = styled(Button)`
  width: 100%;
  margin: 10px 0px 10px 10px;
  font-size: 1.2em;
  font-weight: 600;
  ${padding}
  cursor: pointer;
`;

const FollowingCTA = withRouter(({ history, CTAto, tableOfContentsId, ...rest }) => (
  <StyledFollowingCTA padding={['4px 8px', '10px']} {...rest}>
    <StyledCTAButton
      onClick={() => {
        history.push('/plan-de-pension');
      }}
    >
      Mejora tu pensión con nosotros
    </StyledCTAButton>

    <StyledGoToTableOfContents>
      <Icon
        icon="hamburguer"
        size={30}
        color="white"
        onClick={() => {
          scroller.scrollTo(tableOfContentsId);
        }}
      />
    </StyledGoToTableOfContents>
  </StyledFollowingCTA>
));

export default FollowingCTA;
